/** V1 pin permission mirror of PinService.assertCanPin */
export function canManagePins(conversation) {
  if (!conversation) return false;
  const type = conversation.conversationType;
  if (type === 'CUSTOMER_SERVICE') return false;
  if (type === 'DIRECT') return true;
  if (type === 'GROUP' || type === 'BUSINESS_GROUP') {
    const role = conversation.myRole;
    return role === 'OWNER' || role === 'ADMIN';
  }
  return false;
}
